import { BrowserModule } from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import { NgModule } from '@angular/core';

import {ChartsComponent} from './charts.component';
import {ChartsService} from './charts.service';

@NgModule({
  declarations: [ChartsComponent],
  imports: [
    BrowserModule, FormsModule],
  exports:[ChartsComponent],
  providers: [ChartsService],
  entryComponents: []
})
export class ChartsModule { }